module.exports = __webpack_public_path__ + "7fc58e93a8422989a4f1d2770fdb5d46.svg";